<template>
	<section id="page-heading" v-if="currentPage && currentPage.acf" class="page-heading" :class="'type-'+currentPostType">
        <div class="inner padding-bottom-lg" :class="currentPage.featured_image ? 'has-image' : 'no-image'">
            <div class="container small">
                <h1 class="page-title dm dm--60">{{currentPage.title}}</h1>
                <p class="excerpt jost jost--25 font--500" v-if="currentPage.excerpt" v-html="currentPage.excerpt" />
            </div>
        </div>
        <VideoPopup v-if="currentPage.acf.video" @close="showHidePopup" :isOpen="popupOpen" :videoUrl="currentPage.acf.video" />
        
        <div v-if="currentPage.type == 'events'" class="padding-bottom-lg event-head-meta">
            <SingleEventMeta class="text-center container small" />
        </div>

        <template v-if="currentPostType === 'events' && isArchive">
            <div class="venu-archive-filters padding-bottom-lg">
                <div class="container font--700 small">
                    <div class="search-area">
                        <input name="search" v-model="searchValue" placeholder="Søk i listen" />
                        <svg width="25" height="25" viewBox="0 0 25 25" xmlns="http://www.w3.org/2000/svg"><path d="M23.77 22.771l-5.95-6.188a10.061 10.061 0 002.367-6.49C20.188 4.529 15.66 0 10.095 0 4.528 0 0 4.528 0 10.094c0 5.565 4.528 10.094 10.094 10.094 2.09 0 4.08-.63 5.783-1.827l5.995 6.235c.25.26.587.404.949.404a1.318 1.318 0 00.949-2.229zM10.093 2.633c4.114 0 7.46 3.347 7.46 7.46 0 4.115-3.346 7.461-7.46 7.461s-7.46-3.346-7.46-7.46 3.346-7.46 7.46-7.46z" fill="#143D54" fill-rule="evenodd"/></svg>
                    </div>
                </div>
            </div>
        </template>

        <template v-if="currentPostType === 'post' && isArchive && isTaxonomiesLoaded && storedTaxonomy('category')">
            <div class="post-archive-filters padding-bottom-lg">
                <div class="container font--700 small">
                    <div class="select-area">
                        <div :class="{'has-selections' : (activeFilters[categoryPostKey] && activeFilters[categoryPostKey].length) }" class="select-category">
                            <select v-model="selectedCategory" @change="onFilterInputChange(categoryPostKey, selectedCategory)" name="venue-category">
                                <option value="">Kategori</option>
                                <option v-for="category in storedTaxonomy('category')" :disabled="isOptionInUse(categoryPostKey, category.slug)" :key="category.slug" :value="category.slug" v-html="category.name"></option>
                            </select>
                            
                            <svg width="18" height="25" viewBox="0 0 18 25" xmlns="http://www.w3.org/2000/svg"><defs><path d="M15.653 15.182a1.274 1.274 0 011.818 0c.491.509.491 1.31 0 1.818l-7.618 7.619a1.305 1.305 0 01-.926.381 1.31 1.31 0 01-.928-.381L.38 17a1.274 1.274 0 010-1.818 1.274 1.274 0 011.818 0l5.437 5.455V1.273A1.279 1.279 0 018.926 0c.709 0 1.272.564 1.272 1.273v19.363l5.455-5.454z" id="a"/></defs><path d="M15.653 15.182a1.274 1.274 0 011.818 0c.491.509.491 1.31 0 1.818l-7.618 7.619a1.305 1.305 0 01-.926.381 1.31 1.31 0 01-.928-.381L.38 17a1.274 1.274 0 010-1.818 1.274 1.274 0 011.818 0l5.437 5.455V1.273A1.279 1.279 0 018.926 0c.709 0 1.272.564 1.272 1.273v19.363l5.455-5.454z" fill="#143D54" fill-rule="evenodd"/></svg>
                        </div>
                        <ul v-if="activeFilters[categoryPostKey] && activeFilters[categoryPostKey].length" class="selected-values">
                            <li v-for="slug in activeFilters[categoryPostKey]" :key="'sel-'+slug">
                                <span class="label" v-html="storedTaxonomyBySlug(categoryPostKey, slug).name"></span>
                                <span class="remove" v-on:click="removeFilterValue(categoryPostKey, slug)">
                                    <svg width="25" height="25" viewBox="0 0 25 25" xmlns="http://www.w3.org/2000/svg"><path d="M12.5 0A1.5 1.5 0 0114 1.5V11h9.5a1.5 1.5 0 010 3H14v9.5a1.5 1.5 0 01-3 0V14H1.5a1.5 1.5 0 010-3H11V1.5A1.5 1.5 0 0112.5 0z" fill="#143D54" fill-rule="evenodd"/></svg>
                                </span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </template>

        <template v-if="currentPostType === 'venu' && isArchive && isTaxonomiesLoaded && storedTaxonomy('venu_category')">
            <div class="venu-archive-filters padding-bottom-lg">
                <div class="container font--700 small">
                    <div class="search-area">
                        <input name="search" v-model="searchValue" placeholder="Søk i listen" />
                        <svg width="25" height="25" viewBox="0 0 25 25" xmlns="http://www.w3.org/2000/svg"><path d="M23.77 22.771l-5.95-6.188a10.061 10.061 0 002.367-6.49C20.188 4.529 15.66 0 10.095 0 4.528 0 0 4.528 0 10.094c0 5.565 4.528 10.094 10.094 10.094 2.09 0 4.08-.63 5.783-1.827l5.995 6.235c.25.26.587.404.949.404a1.318 1.318 0 00.949-2.229zM10.093 2.633c4.114 0 7.46 3.347 7.46 7.46 0 4.115-3.346 7.461-7.46 7.461s-7.46-3.346-7.46-7.46 3.346-7.46 7.46-7.46z" fill="#143D54" fill-rule="evenodd"/></svg>
                    </div>

                    <div class="select-area">
                        <div :class="{'has-selections' : (activeFilters[filterSectionKey] && activeFilters[filterSectionKey].length) }" class="select-category">
                            <select v-model="selectedCategory" @change="onFilterInputChange(filterSectionKey, selectedCategory)" name="venue-category">
                                <option value="">Kategori</option>
                                <option v-for="category in storedTaxonomy('venu_category')" :disabled="isOptionInUse(filterSectionKey, category.slug)" :key="category.slug" :value="category.slug" v-html="category.name"></option>
                            </select>
                            
                            <svg width="18" height="25" viewBox="0 0 18 25" xmlns="http://www.w3.org/2000/svg"><defs><path d="M15.653 15.182a1.274 1.274 0 011.818 0c.491.509.491 1.31 0 1.818l-7.618 7.619a1.305 1.305 0 01-.926.381 1.31 1.31 0 01-.928-.381L.38 17a1.274 1.274 0 010-1.818 1.274 1.274 0 011.818 0l5.437 5.455V1.273A1.279 1.279 0 018.926 0c.709 0 1.272.564 1.272 1.273v19.363l5.455-5.454z" id="a"/></defs><path d="M15.653 15.182a1.274 1.274 0 011.818 0c.491.509.491 1.31 0 1.818l-7.618 7.619a1.305 1.305 0 01-.926.381 1.31 1.31 0 01-.928-.381L.38 17a1.274 1.274 0 010-1.818 1.274 1.274 0 011.818 0l5.437 5.455V1.273A1.279 1.279 0 018.926 0c.709 0 1.272.564 1.272 1.273v19.363l5.455-5.454z" fill="#143D54" fill-rule="evenodd"/></svg>
                        </div>
                        <ul v-if="activeFilters[filterSectionKey] && activeFilters[filterSectionKey].length" class="selected-values">
                            <li v-for="slug in activeFilters[filterSectionKey]" :key="'sel-'+slug">
                                <span class="label" v-html="storedTaxonomyBySlug(filterSectionKey, slug).name"></span>
                                <span class="remove" v-on:click="removeFilterValue(filterSectionKey, slug)">
                                    <svg width="25" height="25" viewBox="0 0 25 25" xmlns="http://www.w3.org/2000/svg"><path d="M12.5 0A1.5 1.5 0 0114 1.5V11h9.5a1.5 1.5 0 010 3H14v9.5a1.5 1.5 0 01-3 0V14H1.5a1.5 1.5 0 010-3H11V1.5A1.5 1.5 0 0112.5 0z" fill="#143D54" fill-rule="evenodd"/></svg>
                                </span>
                            </li>
                        </ul>
                    </div>
                    
                    <div class="select-area area-places">
                        <div v-if="placesLoaded && placesToShow.length" :class="{'has-selections' : (activeFilters[filterPlaceKey] && activeFilters[filterPlaceKey].length) }" class="places select-category">
                            <select v-model="selectedPlace" @change="onFilterInputChange(filterPlaceKey, selectedPlace)" name="venue-place">
                                <option value="">Steder</option>
                                <option v-for="place in placesToShow" :disabled="isOptionInUse(filterPlaceKey, place.id)" :key="place.id" :value="place.id" v-html="place.title"></option>
                            </select>
                            
                            <svg width="18" height="25" viewBox="0 0 18 25" xmlns="http://www.w3.org/2000/svg"><defs><path d="M15.653 15.182a1.274 1.274 0 011.818 0c.491.509.491 1.31 0 1.818l-7.618 7.619a1.305 1.305 0 01-.926.381 1.31 1.31 0 01-.928-.381L.38 17a1.274 1.274 0 010-1.818 1.274 1.274 0 011.818 0l5.437 5.455V1.273A1.279 1.279 0 018.926 0c.709 0 1.272.564 1.272 1.273v19.363l5.455-5.454z" id="a"/></defs><path d="M15.653 15.182a1.274 1.274 0 011.818 0c.491.509.491 1.31 0 1.818l-7.618 7.619a1.305 1.305 0 01-.926.381 1.31 1.31 0 01-.928-.381L.38 17a1.274 1.274 0 010-1.818 1.274 1.274 0 011.818 0l5.437 5.455V1.273A1.279 1.279 0 018.926 0c.709 0 1.272.564 1.272 1.273v19.363l5.455-5.454z" fill="#143D54" fill-rule="evenodd"/></svg>
                        </div>
                        <ul v-if="activeFilters[filterPlaceKey] && activeFilters[filterPlaceKey].length" class="selected-values">
                            <li v-for="id in activeFilters[filterPlaceKey]" :key="'sel-'+id">
                                <span class="label" v-html="getPlaceById(id).title"></span>
                                <span class="remove" v-on:click="removeFilterValue(filterPlaceKey, id)">
                                    <svg width="25" height="25" viewBox="0 0 25 25" xmlns="http://www.w3.org/2000/svg"><path d="M12.5 0A1.5 1.5 0 0114 1.5V11h9.5a1.5 1.5 0 010 3H14v9.5a1.5 1.5 0 01-3 0V14H1.5a1.5 1.5 0 010-3H11V1.5A1.5 1.5 0 0112.5 0z" fill="#143D54" fill-rule="evenodd"/></svg>
                                </span>
                            </li>
                        </ul>
                    </div>

                </div>
            </div>
        </template>

        <div class="post-image">
            <WpImage
                v-if="currentPage.featured_image && (currentPage.type == 'post' || currentPage.type == 'venu' || currentPage.type == 'events') && !isArchive"
                :image="currentPage.featured_image"
                size="extra_large"
                class="featured-image-container container"
                background 
                cover
                caption
                />
            <Button 
                v-if="currentPage.acf.video" 
                @click.native="showHidePopup" 
                :outlined="false" 
                :hasIcon="true" 
                type="white" 
                class="play-btn-banner text-uppercase font--600">
                Se filmen<span v-html="displayPlayButton()"/>
            </Button>
        </div>
    </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { formatOutputValues } from '@/helpers'
import _uniq from 'lodash.uniq';
import { play } from '@/components/../icons';

import WpImage from '@/components/elements/WpImage'
import Button from '@/components/elements/Button'
import VideoPopup from '@/components/elements/VideoPopup'
import SingleEventMeta from '@/components/parts/SingleEventMeta'

export default {
    name: 'single-heading',
    data(){
        return{
            placesLoaded: false,
            allPlaces: [],
            popupOpen: false,
            selectedCategory: '',
            selectedPlace: '',
            searchValue: '',
            categoryPostKey: 'category',
            filterSectionKey: 'venu_category',
            filterPlaceKey: 'venu_places',
            activeFilters: {
                venu_places: [],
                venu_category: [],
                category: []
            }
        }
    },
    components: {
        WpImage,
        Button,
        VideoPopup,
        SingleEventMeta
    },
    watch: {
        'activeFilters.category'(val){
            this.$emit('changePostCategory', val)
        },
        'activeFilters.venu_category'(val){
            this.$emit('changeCategory', val)
        },
        'activeFilters.venu_places'(val){
            if(val && val.length){
                const data = this.allPlaces.filter(e => ~val.indexOf( Number(e.id) )  ).map( e => e.acf.zip_list ).flat()
                this.$emit('changePlace', data)
            }else{
                this.$emit('changePlace', val)
            }
        },
        searchValue(val){
            this.$emit('changeSearch', val)

        }
    },
    mounted(){
        if(this.currentPostType === 'venu'){
            this.loadPlaces()
        }
    },
    methods:{
        
        getPlaceById(id){
            if(this.loadPlaces && this.allPlaces && this.allPlaces.length) return this.allPlaces.find(e => Number(e.id) === Number(id))
            else null
        },
        showHidePopup(){
            this.popupOpen = !this.popupOpen;
        },
        displayPlayButton(){
            return play();
        },
        isOptionInUse(filterKey, slug) {
            return this.activeFilters[filterKey].includes(slug);
        },
        onFilterInputChange(filterKey, val) {
            this.selectedCategory = ''; // reset dropdowns after selection
            this.selectedPlace = ''; // reset dropdowns after selection
            this.searchValue = ''; // reset search input
            this.activeFilters[filterKey] = _uniq([...this.activeFilters[filterKey], val]);
        },
        removeFilterValue(filterSectionKey, val) {
            this.activeFilters[filterSectionKey] = this.activeFilters[filterSectionKey].filter(slug => slug !== val);
            this.searchValue = ''; // reset search input
        },
        ...mapActions([
			'getPost',
		]),
		loadPlaces(){
			const VM = this;
            const opt = {
                type: 'places',
				order_by : 'title',
				order : 'ASC',
				limit: 50000,
            }
			VM.getPost(opt).then(res => {
				const { posts } = res.data;
				if(posts && posts.length){
					VM.allPlaces = posts;
					VM.placesLoaded = true;
				}
			})
		},
    },
    computed: {
        ...mapGetters([
            'getPostData',
            'currentPage',
            'currentPostType',
            'storedTaxonomy',
            'isTaxonomiesLoaded',
            'isArchive',
            'storedTaxonomyBySlug'
        ]),
        placesToShow(){
            //just make it not show empty places
            if( this.allPlaces && this.allPlaces.length && this.getPostData && this.getPostData['venu'] && this.getPostData['venu'].length ){
                try {
                    //make unique elements
                    const zipList = [... new Set(this.getPostData['venu'].map( v => v.acf.zip ))]
                    return this.allPlaces.filter( e => e.acf.zip_list.some( z => zipList.includes(z) ) )
                } catch (error) {
                    console.warn('error while trying to filter empty places')
                }
            }
            
            //if there is error in above, it is better to show are least all than nothing or error
            return this.allPlace
        },
        categories(){
            let cats = [];
            let taxonomy = 'category'
            if(this.currentPage.type === 'post' && this.currentPage.acf && this.currentPage.acf.category){
                cats = this.currentPage.acf.category
            }
            if(this.currentPage.type === 'clinic' && this.currentPage.acf && this.currentPage.acf.clinic_category){
                cats = [this.currentPage.acf.clinic_category]
                taxonomy = 'clinic_category'
            }
            if(this.currentPage.type === 'recipe' && this.currentPage.acf && this.currentPage.acf.meal_type){
                cats = this.currentPage.acf.meal_type
                taxonomy = 'meal_type'
            }

            const findCategory = cats.map(id => this.storedTaxonomy(taxonomy, id));

            cats = findCategory && findCategory.length ? findCategory.map(c=> c.name) : []

            return formatOutputValues(cats)
        },
    },
    
}
</script>

<style lang="scss">
@import "@/assets/vars.scss";
@import "@/assets/mixins.scss";
.post-image{
    position: relative;
    .play-btn-banner{
        position: absolute;
        top: 50%;
        left: 50%;
        z-index: 10;
        transform: translate(-50%, -50%);
    }
}

.venu-archive-filters,
.post-archive-filters{
    background-color: $lightBlue;
    .selected-values{
        background-color: #fff;
        border-bottom-right-radius: 25px;
        border-bottom-left-radius: 25px;
        list-style: none;
        padding: 5px 25px;
        margin: 0;
        text-transform: uppercase;
        font-weight: 400;
        max-width: 250px;
        min-width: 250px;
        
        @include mquery($phone){
            max-width: 100%;
        }
        li{
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 5px 0;
        }
        .remove{
            cursor: pointer;
            line-height: 0;
            position: relative;
            right: -2px;
            svg{
                transform: rotate(45deg);
            }
        }
    }
    .container{
        display: flex;
        @include mquery($phone){
            display: block;
        }
    }
    .select-area{
        &.area-places{
            margin-left: 25px;
            @include mquery($phone){
                margin-left: 0
            }

        }
    }
    .select-category{
        position: relative;
        max-width: 250px;
        min-width: 250px;
        
        @include mquery($phone){
            max-width: 100%;
            margin-top: 25px;
        }
        &.has-selections{
            &:after{
                content: '';
                position: absolute;
                width: 100%;
                z-index: 1;
                background: #fff;
                height: 50%;
                left: 0;
                top: 50%;
            }
        }
        svg{
            position: absolute;
            z-index: 8;
            pointer-events: none;
            right: 25px;
            top: 50%;
            transform: translateY(-50%);
        }
        select{
            z-index: 5;
            position: relative;;
            width: 100%;
            cursor: pointer;
            color: $dark;
            background: $green;
            text-transform: uppercase;
            border-radius: 50px;
            border: none;
            height: 50px;
            padding-left: 25px;
            padding-right: 25px;
            font-weight: 700;
            -webkit-appearance: none;
            -moz-appearance: none;
            text-indent: 1px;
            text-overflow: '';
            
        }
        option{
            background-color: #fff;
            color: $dark;
        };
    }
    .search-area{
        position: relative;
        flex-grow: 1;
        height: 100%;
        margin-right: 25px;
        @include mquery($phone){
            margin-right: 0;
        }
        svg{
            position: absolute;
            right: 25px;
            top: 50%;
            transform: translateY(-50%);
        }
        input{
            width: 100%;
            cursor: pointer;
            font-weight: 700;
            text-transform: uppercase;
            border-radius: 50px;
            border: none;
            height: 50px;
            padding-left: 25px;
            padding-right: 25px;
            &::placeholder{
                color: $dark;
            }
        }
    }
}

.post-archive-filters{
    
    .select-category, .selected-values{
        max-width: 300px;
        min-width: 300px;
        
        @include mquery($phone){
            max-width: 100%;
        }
    }

}



.event-head-meta{ 
    background: $lightBlue;
    color: $dark
}
.page-heading{
    max-width: 1440px;
    margin: 0 auto;
    overflow: hidden;
    .container.small{
        max-width: 860px;
    }
    &.type-page{
        .page-title, .excerpt{
            text-align: left;
        }

    }
    .page-title, .excerpt{
        margin-top: 0;
        margin-bottom: 0;
        text-align: center;
    }
    .excerpt{
        margin-top: 25px;
    }
    .wp-image-vue{
        overflow: visible;
        .image{
            position: relative;
            z-index: 10;
        }
        .bger{
            padding-bottom: calc(56.4% - 134px);
            height: 0;
            background-position: center center;
            border-radius: 0px;
            position: absolute;
            left: 30px;
            right: 30px;
            top: 0;
            z-index: -1;
            background: $lightBlue;
            &:after{
                content: '';
                position: absolute;
                background: $lightBlue;
                position: absolute;
                left:-300px;
                right:-300px;
                bottom:0;
                z-index: -1;
                top: 0;
            }
        }
    }
    .inner{
        padding-top: 200px;
        background-color: $lightBlue;
        color: $dark;
    }
    .featured-image-container{
        //margin-bottom: -100px
    }
}
</style>
